module.exports = __webpack_public_path__ + "assets/media/level-01.0b21aa52.png";